<div class="block">
    <div class="">
        <i class="fa fa-plus fa-1x custom-add-btn" aria-hidden="true" title="{{ 'ADD' | translate }}"
            (click)="nextStep()"></i>
    </div>
    <!--search area-->
    <div class=" master-form">
        <app-fast-search [searchType]="SecurityParms" [appCodes]="[1020,1024,1017,1018,1243]"
            [placeholderText]="translate.currentLang == 'ar' ? searchPlaceholder.nameAr : searchPlaceholder.nameEn"
            #userSearch (toggle)="togglefillter()" (searchKeys)="onSearchClick($event)" ngDefaultControl>
        </app-fast-search>
    </div>
</div>
<!-- <p-dataTable tableStyleClass="table table-bordered table-striped ui-state-highlight" selectionMode="single"
    [value]="users" [rows]="10" [totalRecords]="totalRecords" [lazy]="true" (onPage)="paginate($event)"
    [paginator]="true" [pageLinks]="3" [rowsPerPageOptions]="[5,10,20,50,100]"> -->




    <p-dataTable tableStyleClass="table table-bordered table-striped ui-state-highlight" [value]="users"
  selectionMode="single" [rows]="10" [totalRecords]="totalRecords" [lazy]="true" (onPage)="paginate($event)"
  [paginator]="true" [pageLinks]="3" [rowsPerPageOptions]="[5,10,20,50,100]">

    <p-column field="userID" header="{{ 'USERID' | translate }}" [sortable]="true"></p-column>
    <p-column field="userName" header="{{ 'USERNAME' | translate }}" [sortable]="true"></p-column>
    <p-column field="empCode" header="{{ 'empCode' | translate }}" [sortable]="true"></p-column>
    <p-column field="{{translate.currentLang == 'ar' ? 'empNameAr' : 'empNameEn'}}" header="{{ 'EMPName' | translate }}"
        [sortable]="true"></p-column>
    <!-- <p-column field="{{translate.currentLang == 'ar' ? 'empManagementNameAr' : 'empManagementNameEn'}}"
        header="{{ 'JOBID' | translate }}" [sortable]="true"></p-column> -->
    <p-column field="{{translate.currentLang == 'ar' ? 'groupNameAr' : 'groupNameEn'}}"
        header="{{ 'GroupName' | translate }}" [sortable]="true"></p-column>
    <p-column field="admin" header="{{ 'ADMIN' | translate }}">
        <ng-template pTemplate="options" let-row="rowData">
            <i class="fa dataTableFa"
                [ngClass]="{'fa-check-square': row['admin'] == true,'fa-square-o':row['admin'] == false}"></i>
        </ng-template>
    </p-column>
    <p-column field="active" header="{{ 'ACTIVE' | translate }}">
        <ng-template pTemplate="options" let-row="rowData">
            <i class="fa dataTableFa"
                [ngClass]="{'fa-check-square': row['active'] == true,'fa-square-o':row['active'] == false}"></i>
        </ng-template>
    </p-column>
    <p-column>
        <ng-template pTemplate="options" let-row="rowData">
            <div *ngIf="row['securityLevel'] >= CurrentSecurityLevelOfUser">
                <icon-action (clicked)="rowIconClick($event,row)" [appCodes]="[404]">
                </icon-action>
            </div>
        </ng-template>
    </p-column>
</p-dataTable>


